<template>
  <el-dialog title="修改邻里豆返还比例" :visible.sync="visible" width="50%" @close="handleClose">
    <el-form ref="form" :model="formData" label-width="150px" label-position="right">
      <el-form-item label="房屋" v-if="payerObjNames">
        <el-input 
          v-model="payerObjNames" 
          :disabled="true" 
          type="textarea" 
          :rows="isBatch ? 3 : 1"
          class="disabled-input"
        />
      </el-form-item>
      <el-form-item label="邻里豆返还比例" prop="returnLlBeanRate" :rules="[
        { required: true, message: '邻里豆返还比例不能为空', trigger: 'blur' },
        { type: 'number', min: 0, max: 1000, message: '邻里豆返还比例必须在0-1000之间', trigger: 'blur' }
      ]">
        <div style="display: flex; align-items: center;">
          <el-input-number 
            v-model="formData.returnLlBeanRate" 
            placeholder="请输入邻里豆返还比例 (0-1000)" 
            :min="0" 
            :max="1000" 
            :precision="0"
            style="flex: 1;"
          />
          <span style="margin-left: 10px;">%</span>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">
        取消
      </el-button>
      <el-button type="primary" @click="handleSubmit">
        提交
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'Audit',
  data() {
    return {
      visible: false,
      isBatch: false,
      payerObjNames: '',
      formData: {
        feeIds: '',
        communityId: '',
        returnLlBeanRate: null
      }
    }
  },
  methods: {
    open(data) {
      this.resetForm()
      if (data) {
        // 单个修改时包装成数组，批量时直接使用数组
        this.isBatch = Array.isArray(data.feeIds)
        this.formData.feeIds = Array.isArray(data.feeIds) ? data.feeIds : [data.feeIds]
        this.formData.communityId = data.communityId
        this.formData.returnLlBeanRate = data.returnLlBeanRate || null
        this.payerObjNames = Array.isArray(data.payerObjName)
          ? data.payerObjName.join('、')
          : data.payerObjName
      }
      this.visible = true
    },
    handleClose() {
      this.$refs.form.resetFields()
    },
    resetForm() {
      this.isBatch = false
      this.payerObjNames = ''
      this.formData = {
        feeIds: [],
        communityId: '',
        returnLlBeanRate: null
      }
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$emit('success', {
            feeIds: this.formData.feeIds,
            communityId: this.formData.communityId,
            returnLlBeanRate: this.formData.returnLlBeanRate
          })
          this.visible = false
        }
      })
    }
  }
}
</script>

<style scoped>
.disabled-input /deep/ .el-textarea__inner {
  color: #303133 !important;
  background-color: #f5f7fa;
  cursor: not-allowed;
}
</style>